import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import * as API from "../utils/api";
import { useAuth } from "./AuthContext";

const TeamsContext = createContext();

export function TeamsProvider({ children }) {
  const { authState } = useAuth(); // Get user from AuthContext
  const [teamMemberList, setTeamMemberList] = useState([]);
  const [teamMemberLoader, setTeamMemberLoader] = useState(false);

  const loadTeamMembers = useCallback(async () => {
    try {
      setTeamMemberLoader(true);
      // Make sure 'user' is available here
      const resp = await API.getTeamMembers(authState?.user, "recurring");
      const formattedList =
        resp?.employees?.map((member) => ({
          label: member?.display_name,
          value: member?.id,
        })) || [];

      setTeamMemberList(formattedList);
    } catch (error) {
      console.error("Error loading team members:", error);
    } finally {
      setTeamMemberLoader(false);
    }
  }, [authState]);

  useEffect(() => {
    if (
      authState?.isLoggedIn &&
      authState?.user &&
      (authState?.user?.client_admin || authState?.user?.is_employee)
    ) {
      loadTeamMembers();
    }
  }, [authState, loadTeamMembers]);

  const contextValue = {
    teamMemberList,
    teamMemberLoader,
    // loadTeamMembers,
    isLoading: teamMemberLoader,
  };

  return (
    <TeamsContext.Provider value={contextValue}>
      {children}
    </TeamsContext.Provider>
  );
}

export function useTeams() {
  const context = useContext(TeamsContext);
  if (!context) {
    throw new Error("useTeams must be used within a TeamsProvider");
  }
  return context;
}
